import { BadRequest, ServiceUnavailable } from 'common/errors'
import { useEffect, useState } from 'react'
import { signUp } from '../api/website-public-page-api'
import { PublicPageFieldSlugEnum } from '../enums/public-page-field-slug-enum'
import { validateEmailField, validateEmptyField } from '../utils/validation'

type ErrorFields = Partial<Record<PublicPageFieldSlugEnum | 'root', string[]>>

export const useSignUpSubmit = () => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<ErrorFields>()
  const [email, setEmail] = useState('')

  useEffect(() => {
    if (errors?.[PublicPageFieldSlugEnum.Email]) {
      setErrors(prev => ({
        ...prev,
        [PublicPageFieldSlugEnum.Email]: undefined,
      }))
    }
  }, [email])

  const handleSubmit = async () => {
    const emptyFieldError = validateEmptyField(email)

    if (emptyFieldError && emptyFieldError.length > 0) {
      setErrors({ [PublicPageFieldSlugEnum.Email]: emptyFieldError })
      return
    }

    const emailFieldError = validateEmailField(email)
    if (emailFieldError && emailFieldError.length > 0) {
      setErrors({ [PublicPageFieldSlugEnum.Email]: emailFieldError })
      return
    }
    setErrors(undefined)
    try {
      setLoading(true)
      const response = await signUp(email)
      const redirect = response?.data?.redirect || '/thank-you'
      window.location.replace(redirect)
    } catch (e) {
      if (e instanceof ServiceUnavailable) {
        setErrors({ root: ['core.errors.service_temporary_unavailable'] })
      } else if (e instanceof BadRequest) {
        const { fields, common } = e.response.data.errors || {}

        const newErrors: ErrorFields = {}
        if (fields) {
          Object.entries(fields).forEach(([key, messages]) => {
            if (key === PublicPageFieldSlugEnum.Email) {
              newErrors[PublicPageFieldSlugEnum.Email] = [messages?.join('\n')]
            }
          })
        }
        if (common) {
          newErrors.root = [common?.join('\n')]
        }
        setErrors(newErrors)
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    errors,
    email,
    setEmail,
    handleSubmit,
  }
}
